import { render, staticRenderFns } from "./InitiatedSettlement.vue?vue&type=template&id=f70ef734"
import script from "./InitiatedSettlement.vue?vue&type=script&lang=js"
export * from "./InitiatedSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports